module.exports = __webpack_public_path__ + "static/media/schedule.a37ab8a1.png";